import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { SETTING_TENANTS_SEARCH_COLUMNS } from "./consts";
import { TenantsSearchResultsProps } from "./types";

const TenantsSearchResults: React.FC<TenantsSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    storageByTenant,
    onRowClick,
    onEventClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={SETTING_TENANTS_SEARCH_COLUMNS(storageByTenant)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        onEventClick={onEventClick}
      />
    </>
  );
};
export default memo(TenantsSearchResults);
